import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { defaultListParams } from "src/features/common/constants/defaultListParams";
import { cleanParams } from "src/features/common/helpers/cleanParams";
import { FilterFields } from "../types/FilterFields";
import { DefaultListParams } from "src/features/common/types/DefaultListParams";
import { useChains } from "src/components/FetchConfig";

const useGetListParams = () => {
  const [searchedParams] = useSearchParams();
  const [isInit, setIsInit] = useState(true);
  const { selectChainByPieces } = useChains();

  const getListParams = (fields: FilterFields) => {
    //handle search params
    //also update useRenderFilters
    const searchedParamsBatchId = searchedParams.get("batchId");
    if (searchedParamsBatchId && isInit) {
      setIsInit(false);
      const params: DefaultListParams = {
        ...defaultListParams,
        batch_id: [searchedParamsBatchId],
      };
      return cleanParams(params);
    }

    const {
      creationTime,
      lastModifiedTime,
      batchId,
      status,
      chainName: chain_name,
      operationType: operation_types,
    } = fields;

    const { start: dateCreatedFrom, end: dateCreatedTo } = creationTime;

    const { start: dateLastModifiedFrom, end: dateLastModifiedTo } =
      lastModifiedTime;

    const { chain_id, chain_type } = selectChainByPieces({ chain_name });

    const batchIds = batchId
      .split(",")
      .filter((item) => item)
      .map((item) => item.trim());

    const params: DefaultListParams = {
      ...defaultListParams,
      dateCreatedFrom,
      dateCreatedTo,
      dateLastModifiedFrom,
      dateLastModifiedTo,
      chain_id,
      chain_type,
      batch_id: batchIds,
      status: status,
      operation_types,
    };

    return cleanParams(params);
  };

  return {
    getListParams,
  };
};

export default useGetListParams;
